import { encrypt } from "../../utils/cryptojs";
import { requestForApi } from "../../utils/httpUtil";

/**
 * 用户登录
 * @param account
 * @param password
 * @returns
 */
export async function login(
  username: string,
  password: string,
  grant_type: string
) {
  // 登录密码加密
  const encryptPwd = encrypt(password);

  const res = await requestForApi(
    `/oauth/token?username=${username}&password=${encryptPwd}&grant_type=${grant_type}`,
    {
      method: "POST",
    }
  );
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}

/**
 * 获取当前用户信息
 * @returns
 */
export async function getCurrentUser() {
  const res = await requestForApi("/api/v1/main/users/current");
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data.obj;
}
